export function Input(props) {
  return <input style={{ padding: "6px", width: "100%" }} {...props} />;
}
